<template>
  <button
    ref="container"
    @mousedown="addRipple"
    :class="`ims-button ripple-outer ims-button-${color} ims-button-${type} ims-button-${size} btn-${size}  ${classes.join(' ')}`"
    @click="$emit('click')"
  >
    <transition-group class="ripples" name="grow" tag="div">
      <div
        class="ripple"
        v-for="ripple in ripples"
        :key="ripple.id"
        :style="{
            top: ripple.top,
            left: ripple.left,
            width: ripple.width,
            height: ripple.height,
            background: rippleColor
          }"
      ></div>
    </transition-group>
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    rippleColor: {
      type: String,
      default() {
        return "rgba(200, 200, 200, 0.3)";
      }
    },
    color: {
      type: String,
      default() {
        return "plain";
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    },
    size: {
      type: String,
      default() {
        return "md";
      }
    }
  },
  data() {
    return {
      ripples: [],
      classes: []
    };
  },
  computed: {},
  mounted() {
    // Calculate width and height
    const width = this.$refs.container.offsetWidth;
    const height = this.$refs.container.offsetHeight;
    // Make ripple width the width or height - depending on largest
    this.rippleWidth = width > height ? width : height;
    // Make half ripple
    this.halfRippleWidth = this.rippleWidth / 2;
    // Listen for mouse down
    window.addEventListener("mouseup", this.purgeRipples);
    //

    if (["clear", "solid", "outline", "link"].indexOf(this.type) > -1) {
      this.classes.push("btn");
      this.classes.push(`btn-${this.type}`);
    }
  },
  beforeDestroy() {
    // Listen for mouse down
    window.removeEventListener("mouseup", this.purgeRipples);
  },
  methods: {
    addRipple(e) {
      const { left, top } = this.$refs.container.getBoundingClientRect();
      const rippleId = Date.now();
      this.ripples.push({
        width: `${this.rippleWidth}px`,
        height: `${this.rippleWidth}px`,
        left: `${e.clientX - left - this.halfRippleWidth}px`,
        top: `${e.clientY - top - this.halfRippleWidth}px`,
        id: rippleId
      });
    },
    purgeRipples() {
      this.ripples = [];
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";

.ims-button {
  outline: none;
  &:focus,
  &:hover {
    outline: none !important;
  }

  &.ims-button-solid {
    background-color: $primary;
    color: #fff;
    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
    &.ims-button-primary,
    &.ims-button-blue {
      background-color: $primary;
      color: #fff;
      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
    &.ims-button-red {
      background-color: $red;
      color: #fff;
      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
    &.ims-button-green {
      background-color: $green;
      color: #fff;
      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
    &.ims-button-dark {
      background-color: $gray-800;
      color: #fff;
      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
    &.ims-button-light {
      background-color: $gray-100;
      color: $primary;
    }
    &.ims-button-white {
      background-color: #fff;
      border: solid 1px rgba(0, 0, 0, 0.132);
      box-shadow: 0px 5px 10px -3px rgba(0, 0, 0, 0.1);
      color: $primary;
    }
  } // end solid

  &.ims-button-clear {
    &.ims-button-primary,
    &.ims-button-blue {
      color: $primary;
      background-color: transparent;
    }
    &.ims-button-red {
      color: $red;
      background-color: transparent;
    }
    &.ims-button-green {
      color: $green;
      background-color: transparent;
    }
    &.ims-button-dark {
      color: $gray-800;
      background-color: transparent;
    }
    &.ims-button-light {
      color: $gray-100;
      background-color: transparent;
    }
    &.ims-button-white {
      color: #fff;
      background-color: transparent;
    }
  } // end clear;
}

.ripple-outer {
  position: relative;
  z-index: 1;
  overflow: hidden;
  cursor: pointer;
  .ripples {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    pointer-events: none;
  }

  .ripple {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 50%;
    opacity: 0;
    pointer-events: none;
  }

  .grow-enter-active,
  .grow-enter-to-active {
    transition: all 1500ms ease-out;
  }
  .grow-leave-active,
  .grow-leave-to-active {
    transition: all 700ms ease-out;
  }

  .grow-enter {
    transform: scale(0);
    opacity: 1;
  }

  .grow-enter-to {
    transform: scale(4);
    opacity: 1;
  }

  .grow-leave {
    transform: scale(4);
    opacity: 1;
  }
  .grow-leave-to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>